/**
 * Main app Module
 *
 * All other modules should be listed as dependencies here
 */

angular
  .module('mmp', [
    'members',
    'fields',
    'session',
    'log',
    'invoices',
    'settings',
    'announcements',
    'expenseclaim',
    'importer',
    'updreqs',
    'membercard',
    'supersearch',
    'mooney',
    'messages',
    'directives',
    'groups',
    'balance',
    'docs',
    '$strap.directives',
    'ngRoute',
    'mm.unsavedChanges',
    'ui.select2',
    'ui.sortable',
  ])
  .config(['$routeProvider', '$locationProvider', '$httpProvider', '$sceProvider', '$anchorScrollProvider', function ($routeProvider, $locationProvider, $httpProvider, $sceProvider, $anchorScrollProvider) {
    $httpProvider.defaults.headers.common['X-CSRFToken'] = (/\bcsrftoken=(.*?)(;|$)/.exec(document.cookie) || [])[1]
    // fix nodecms anchor links by not scrolling to top
    if (location.pathname === '/') {
      $anchorScrollProvider.disableAutoScrolling()
      $locationProvider.html5Mode(false)
    } else {
      $locationProvider.html5Mode(true)
    }
    $sceProvider.enabled(false)
    $routeProvider
      .when(CONFIG.url.dashboard.index(), {
        controller: 'DashboardCtrl',
        templateUrl: '/r/static/templates/dashboard.html',
      })
      .otherwise({instantLoad: true, templateUrl: '/r/static/templates/404.html'})

    $httpProvider.interceptors.push(['$q', function ($q) {
      return {
        request: function (config) {
          if (config.url.indexOf('/r/static/templates') !== -1) {
            //$('div.content, #footer').hide();
            //$('div#loader').show();
            // if the url has been loaded to the template cache, don't add the build id to the url; it should be up to date.
            if (!document.getElementById(config.url)) {
              config.url = config.url + '?b=' + window.a4build
            }
          } else {
            config.url += '?_=' + new Date().getTime()
          }
          return config || $q.when(config)
        },
        /*
        'response': function(response) {
          // Place for hacks! :-)
          return response || $q.when(response);
        }
        */
      }
    }])
  }])
  .run(['$rootScope', '$filter', '$compile', '$location', '$sce', 'utils', 'notify', 'Settings', function ($rootScope, $filter, $compile, $location, $sce, utils, notify, Settings) {
    if (/MSIE 10/.test(navigator.userAgent)) {
      $('html').addClass('ie10')
    }

    // We do this so templates can access CONFIG without having to set it to every local scope
    $rootScope.CONFIG = CONFIG

    $rootScope._ = window._

    /*
    For later if we want to re-enable sce
    $rootScope._ = function() {
      var args = Array.prototype.slice.call(arguments, 0);
      var res = window._.apply(null, args);
      if(args[0].indexOf('HTML_') == 0) {
        res = $sce.trustAsHtml(res);
      }
      return res;
    };
    */

    $rootScope.utils = utils
    $rootScope.notify = notify
    $rootScope.D4GLOBALS = window.D4GLOBALS
    $rootScope.session = window.D4SESSION

    _.date = function (val) {
      return $filter('date')(val, _('_date_format'))
    }
    _.datetime = function (val) {
      return $filter('date')(val, _('_datetime_format'))
    }
    _.bankref = function (val) {
      val = '' + val
      return val.replace(/(\d)(\d\d\d\d\d)\b/, function (x, y, z) {
        return [y, z].join('\xa0')
      })
    }
    _.amount = function (val) {
      if (typeof val !== 'number') {
        val = parseFloat(val)
      }
      return val.toFixed(2).replace('.', ',')
    }
    _.commaDecimal = function (val) {
      if (typeof val === 'number') {
        return val.toString().replace('.', ',')
      }
      return val
    }

    $rootScope.$watch('session', function () {
      if (
        $rootScope.session &&
        $rootScope.session.user &&
        $rootScope.session.user.site_admin &&
        $location.path().indexOf('edit_me_') === -1 && // TODO: rewrite this condition
        $location.path().indexOf('/r/') === 0 && // TODO: rewrite this condition
        $rootScope.session.get_persistent_data('HelpSeenregdashboard') === '0'
      ) {
        _showContextHelp({
          HelpTitle: _('dashboard_bubble_title'),
          HelpText: _('HTML_dashboard_bubble_text'),
          Context: 'regdashboard',
        })
      }
      // Original Reg Welcome msg:
      // if($rootScope.session && !$rootScope.session.get_persistent_data('RegSeenWelcome')) {
      //   $('#welcome-modal').modal({});
      //   $('#welcome-modal').modal('show');
      //   $rootScope.session.set_persistent_data('RegSeenWelcome', '1');
      // }
    })

    // Anything here will run on each location change
    $rootScope.$on('$routeChangeSuccess', function (event, currentRoute, previousRoute) {
      // Check for any pending notifications
      var _data = notify.check()
      if (_data.htmlContent) {
        var _html = '<span>' + _data.htmlContent + '</span>'
        $rootScope.notification = $compile(_html)(_data.scope || $rootScope)
      } else {
        $rootScope.notification = null
      }

      // Reset any global things
      if (
        $location.path().indexOf('import') === -1 &&
        $location.path().indexOf('fields') === -1 &&
        $location.path().indexOf('groups') === -1
      ) {
        $rootScope.importInProgress = false
      }

      // Ask the Topbar to update the tab selection
      if (window.Topbar) {
        Topbar.updateRegTabs($location.path())
      }

      // Reload settings
      // TODO: maybe reload only after transactions, or when changed
      Settings.get(
        {},
        function (settings) {
          $rootScope.settings = settings
        },
        a4.restErrorFactory($rootScope),
      )

      if (currentRoute.instantLoad) {
        a4.loaded()
      }
    })

    // Override bs-select default term ("Nothing selected")
    $.fn.selectpicker.defaults.noneSelectedText = ''

    $rootScope.filterRemovePerson = function (id, fullname) {
      var _scope = $('.page-content').scope()
      var _newVal = id + '|' + fullname
      var found = false
      for (var i = 0; i < _scope.conditions.length; i++) {
        if (_scope.conditions[i].field == 'id' && _scope.conditions[i].verb == '!a4isoneof') {
          found = true
          _scope.conditions[i].value.push(_newVal)
        }
      }
      if (!found) {
        _scope.conditions.push({
          id: Math.random(),
          field: 'id',
          verb: '!a4isoneof',
          value: [_newVal],
        })
      }
    }

    $rootScope.filterAvailableToSend = function (item) {
      var _scope = $('.page-content').scope()
      if (!_scope.stats) return
      var _stats = _scope.stats['result_' + _scope.msg.msg_media + '_ids']
      return $.inArray(item.id, _stats) > -1
    }
  }])

angular.module('mmp').filter('startFrom', function () {
  return function (input, start) {
    if (input) {
      start = +start //parse to int
      return input.slice(start)
    }
  }
})

angular.module('mmp').filter('newlines', function () {
  return function (text) {
    if (!text) return
    return $('<span/>').text(text).html().replace(/\n/g, '<br />')
  }
})

angular.module('mmp').filter('selflinks', function () {
  return function (text) {
    if (!text) return
    return text.replace(/<a\b((?![^>]*target=)[^>]*)>/gi, '<a target="_self"$1>')
  }
})

angular.module('mmp').filter('linkify', function () {
  return function (text) {
    if (!text) return
    return $('<span/>')
      .html(text)
      .html()
      .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank">$1</a>')
      .replace(/\n/g, '<br />')
  }
})

// This is to prevent browsers from autocompleting fields (https://trello.com/c/O8Kkh3Vl)
angular.module('mmp').filter('splitlabel', ['$sce', function ($sce) {
  return function (text, isAdmin) {
    if (!text) return
    if (!isAdmin) {
      return text // We want to prevent autocompleting only in admin view
    }
    // "ID" seems to be the hardest to prevent autocompleting on, so we'll draw it as an SVG
    if (text === 'ID' || text === 'id') {
      return $sce.trustAsHtml(`
        <svg width="30" height="20" viewBox="0 0 30 20">
          <text x="16" y="15" font-family="Arial" font-size="14" fill="black">${text[0]}</text>
          <text x="20" y="15" font-family="Arial" font-size="14" fill="black">${text[1]}</text>
        </svg>
      `)
    } else {
      let result = ''
      for (let char of text) {
        result += `<span>${a4.esc(char)}</span>`
      }
      return $sce.trustAsHtml(result)
    }
  }
}])

/*
angular.module('mmp').filter('zeropad', function () {
    return function(val) {
      return (val < 10) ? ("0" + val) : val;
    };
});
*/

angular.module('mmp').controller('DashboardCtrl', ['$scope', '$rootScope', function ($scope, $rootScope) {
  $scope.utils.setPageID('dashboard')

  $rootScope.member_dashboard_ok = false
  $rootScope.invoice_dashboard_ok = false
  $rootScope.log_dashboard_ok = false
  $rootScope.announcement_dashboard_ok = false
  $rootScope.updreqs_dashboard_ok = false

  $scope.$watch('session', function () {
    if ($scope.session && $scope.session.customer) {
      $scope.utils.setPageTitle($scope.session.customer.name)
    }
  })

  $scope.$watch(
    'member_dashboard_ok + invoice_dashboard_ok + log_dashboard_ok + announcement_dashboard_ok + updreqs_dashboard_ok',
    function (oldVal, newVal) {
      if (
        $rootScope.member_dashboard_ok &&
        $rootScope.invoice_dashboard_ok &&
        $rootScope.log_dashboard_ok &&
        $rootScope.announcement_dashboard_ok &&
        $rootScope.updreqs_dashboard_ok
      ) {
        setTimeout(function () {
          // Resize boxes
          var $left_boxes = $('#dashboard .pull-left .box')
          var $right_boxes = $('#dashboard .pull-right .box')

          $left_boxes.each(function (i, e) {
            var left_height = $(this).height()
            var right_height = $right_boxes.eq(i).height()

            if (left_height < right_height) {
              $(this).css('height', right_height + 'px')
            } else {
              $right_boxes.eq(i).css('height', left_height + 'px')
            }
          })
        }, 1)
      }
    },
  )
}])

/**
 * Utils Service, add global util functions here.
 * They can be called from any controller via $scope.utils.func()
 */

angular.module('mmp').service('utils', ['$location', function ($location) {
  this.getURL = function () {
    return $location.absUrl()
  }

  this.paginationHandler = function (page, numberOfPages) {
    page = Math.max(page, 0)
    page = Math.min(page, numberOfPages - 1)
    return page
  }

  // see mmp/views.py
  var titlePrefix = document.title
  this.setPageTitle = function (title) {
    if (title) {
      document.title = titlePrefix + title + ' - ' + _('product_name')
    } else {
      document.title = titlePrefix + _('product_name')
    }
  }

  this.setPageID = function (page_id) {
    // Remove any previous page-<something> style classes from body
    $('body').removeClass(function (index, css) {
      return (css.match(/\bpage-\S+/g) || []).join(' ')
    })
    $('body').addClass('page-' + page_id)
    if (/edit_me_h|edit_me_s|get_edit_links/.test(window.location.href)) {
      $('body').addClass('page-edit-me')
    }
  }
}])

/**
 * Notification Service, display an alert on next page view only.
 * Use: $scope.notify.set($scope, 'html string');
 */

angular.module('mmp').factory('notify', ['$compile', '$timeout', function ($compile, $timeout) {
  var myService = {
    htmlContent: null,
    scope: null,
    set: function (scope, htmlContent) {
      myService.scope = scope
      myService.htmlContent = htmlContent
    },
    check: function () {
      var ret = {
        htmlContent: myService.htmlContent,
        scope: myService.scope,
      }
      myService.set(null, null)
      return ret
    },
    instant: function (scope, htmlContent) {
      // Instantly inject a notification
      myService.compile(scope, htmlContent)
      myService.position()

      // If we show an instant notification, fade out after 2 seconds
      $timeout(function () {
        $('.notification-scroll').fadeOut()
      }, 2000)
    },
    compile: function (rootScope, htmlContent) {
      var _html = '<span>' + htmlContent + '</span>'
      rootScope.notification = $compile(_html)(rootScope)
    },
    position: function () {
      // $timeout to allow a digest to occur and render the notification first
      $timeout(function () {
        $('.notification').addClass('notification-scroll').show()
      }, 1)
    },
  }
  return myService
}])

// Explicitly global for the same reason as CONFIG in config.js.
window.a4 = window.a4 || {}

a4.checkStrongholdNotification = function ($rootScope, $scope, $location, $compile) {
  if ($location.hash() === 'stronghold-confirmed') {
    $rootScope.notification = $compile('<span>' + _('stronghold_confirmed') + '</span>')($scope)
  }
}

a4.debounce = function debounce(func, timeout = 300) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

a4.saveFactory = function ($scope, saveFunc) {
  return function (saveFuncParam) {
    if ($scope._sending) {
      return
    }
    $scope._sending = true
    return saveFunc(saveFuncParam)
  }
}

a4.amountStringToCents = function (amount) {
  amount = amount.replace(',', '.')

  // make sure we have two decimals
  if (amount.indexOf('.') === -1) {
    amount += '.00'
  } else if (/\.\d$/.test(amount)) {
    amount += '0'
  }

  if (/^([1-9][0-9]*|0)\.\d\d$/.test(amount)) {
    return parseInt(amount.replace('.', ''))
  } else {
    return NaN
  }
}

a4.restErrorFactory = function ($scope, workingKey, modal = false) {
  return function (data) {
    const errorTarget = modal === true ? '.modal-errors' : 'div.page-content:visible'

    var generalError
    var errorType
    if (data && data.data && data.data.error) {
      if (typeof data.data.error === 'string') {
        errorType = data.data.error
      } else if (typeof data.data.error === 'object') {
        errorType = 'A4ValidationErrors'
      }
    }

    if (errorType == 'A4SessionError') {
      // For security and clarity, forget single-page web app state, go to /@login the "old-school" way
      location.href =
        CONFIG.get('urls.session.login_external') +
        '?' +
        jQuery.param({GOTO: location.pathname == '/' ? '/r/' : location.pathname})
    } else if (errorType == 'A4ValidationErrors') {
      // one or more validation errors
      $scope.errors = {}
      $scope.show_server_error = false

      var top_element_pos = 9999
      var top_element
      $.each(data.data.error, function (input, error) {
        if (input == 'general') {
          generalError = error
          return // skip 'general' errors, ie. those that are not tied to any input.
        }
        var _tagged_errors = []
        $.each(error, function (index, value) {
          _tagged_errors.push(_(value)) // value instanceof Array ? _.apply(undefined, value) : _(value));
        })
        $scope.errors[input] = _tagged_errors
        // for scrolling to the topmost erroneous input:
        setTimeout(function () {
          var errorInput = $('.form-group .error-text:first').parent().find('input, textarea')
          if (errorInput.length > 0) {
            errorInput.get(0).focus()
          } else {
            generalError = true
            $scope.show_server_error = true
          }
        }, 1)
      })
    } else {
      // Some Other Error
      $scope.show_server_error = true
    }

    var injectError = function (tag, placeholders, modal = false) {
      if (modal === false) $('html, body').animate({scrollTop: '0px'})
      // Show some generic error here
      var error = $('<div id="server-error" style="display:none;" class="alert alert-danger"></div>')
      error[/^HTML_/.test(tag) ? 'html' : 'text'](_(tag, placeholders))

      $(errorTarget).find('#server-error').remove().end().prepend(error)
      $(error).fadeIn()
    }

    if (generalError) {
      // validation error, but not tied to a specific visible field
      // NB: optional placeholders parameter for tags.
      injectError(generalError[0], generalError[1], modal)
    } else if ($scope.show_server_error) {
      // "Oops"
      injectError('HTML_js_server_error', null, modal)
    }

    // hide the loader
    a4.loaded($scope, modal)

    // Hide any throbbers
    $scope._sending = false

    // hide throbbers tied to a specific row (invoice_instance for now)
    if (workingKey && $scope.working) {
      delete $scope.working[workingKey]
    }
  }
}

a4.loaded = function ($scope, modal = false) {
  if ($scope && $scope.loading) {
    $scope.loading = false
    $scope.$apply()
  }

  if (modal === true) return

  $('div#loader').hide()
  $('div.content,#footer').show()
  // Work around some issues with bsModal when the ng-click of a modal fires before the hide action
  $('body').removeClass('modal-open')
  $('.modal-backdrop').remove()
}

a4.trimMemberFields = function ($scope) {
  jQuery.each($scope.member, function (k, v) {
    if (typeof v === 'string') {
      v = jQuery.trim(v)
      if (v === '') {
        v = null
      }
      $scope.member[k] = v
    }
  })
}

// NB: Duplicate in nodecms and start-form
a4.getPasswordStrength = function (pw = '') {
  const strengthLevels = [
    {
      text: _('change_password_strength_0'),
      color: '#FF715B',
    },
    {
      text: _('change_password_strength_1'),
      color: '#cf9449',
    },
    {
      text: _('change_password_strength_2'),
      color: '#8caf2e',
    },
    {
      text: _('change_password_strength_3'),
      color: '#5ab919',
    },
    {
      text: _('change_password_strength_4'),
      color: '#0BA500',
    },
  ]

  const strength = (() => {
    // less than 10 characters => not strong enough
    if (pw.length < 10) {
      return 0
    }
    let strength = 1
    if (pw.length >= 16) strength++
    if (pw.length >= 20) strength++
    if (pw.length >= 24) strength++

    // includes both word and non-word characters
    if (/[a-zA-ZåäöÅÄÖ]/i.test(pw) && /[^a-zA-ZåäöÅÄÖ]/.test(pw)) {
      strength++
    }
    // includes both uppercase and lowercase
    if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) strength++

    return Math.min(strength, 4)
  })()

  return {
    strength: strength,
    text: strengthLevels[strength].text,
    color: strengthLevels[strength].color,
  }
}
a4.trimSmsContent = function (content) {
  // This is called when calculating the final length of an sms.
  // Also, the message must be trimmed before sending to the server.
  return $.trim(content.replace(/\r/g, '').replace(/ *\n */g, '\n'))
}

a4.letterPageSeparator = function () {
  // NB! Also in utils.py
  return '__A4LETTERPAGESEPARATOR__'
}

a4.stripLetterPageSeparator = function (str, replacement) {
  replacement = replacement || ' '
  return str.replace(new RegExp(a4.letterPageSeparator(), 'g'), replacement)
}

a4.formatBigAmount = function (n) {
  return n
    .replace(/(\d)(\d\d\d)\b/, function (x, y, z) {
      return [y, z].join('\xa0')
    })
    .replace('.', ',')
}

// msgPreview and msgPreviewCancel are common to all msg models.
a4.msgPreview = function ($scope, Instance) {
  return function () {
    if ($scope.invoice_form && parseInt($scope.msg.amount) > 9999 && parseInt($scope.msg.amount) < 100000) {
      if (
        !confirm(
          _('js_confirm_invoice_big_amount', {amount: a4.formatBigAmount(parseFloat($scope.msg.amount).toFixed(2))}),
        )
      ) {
        return
      }
    }
    $scope.msg.filter = $scope.filter_to_post
    $scope._sending = true

    if ($scope.msg.msg_media === 'sms') {
      $scope.msg.content = a4.trimSmsContent($scope.msg.content)
    } else if ($scope.msg.msg_media === 'letter') {
      if (!$scope.msg.addrecips) {
        var content_field = $scope.invoice_form ? 'description' : 'content'
        $scope.msg[content_field] = $scope.pages
          .map(function (p) {
            return p[content_field]
          })
          .join(a4.letterPageSeparator())
      }
    }

    Instance.preview(
      {},
      jQuery.extend(true, {}, $scope.msg),
      function (data) {
        $scope.previewing = true
        $scope._sending = false
        $scope.msg_preview = data
        if ($scope.msg_preview.fraudulent_content) {
          $scope.settings.stronghold_pending_ = true
          $scope.settings.trust_status_ = 'BLOCKED'
        }
        window.scrollTo(0, 0)
      },
      a4.restErrorFactory($scope),
    )
  }
}

a4.msgPreviewCancel = function ($scope) {
  return function () {
    $scope.previewing = false
    $scope.errors = null
    window.scrollTo(0, 0)
  }
}

// If we need to call the current page angular controller
a4.ngCallback = function (callback, data_obj, iframe_window) {
  iframe_window.location.href = 'about:blank'
  angular
    .element('.page-content')
    .scope()
    .$apply(function (scope) {
      scope[callback](data_obj)
    })
}

a4.esc = function (str) {
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\x22/g, '&quot;')
}

a4.timeout = function (timeout, scope, cb, msec) {
  var t = timeout(cb, msec)
  // if the user navigates away, cancel the timeout
  scope.$on('$destroy', function () {
    timeout.cancel(t)
  })
}

a4.printWindow = function () {
  try {
    if (!document.execCommand('print', false, null)) {
      window.print()
    }
  } catch {
    window.print()
  }
}

/*
// DEBUG version
a4.timeout = function(timeout, scope, cb, msec, dbg_name) {
  console.log(dbg_name + " - setTimeout");
  var t = timeout(function() { console.log(dbg_name + " - triggered!"); cb(); }, msec);
  // if the user navigates away, cancel the timeout
  scope.$on('$destroy', function() { console.log(dbg_name + " - canceling"); timeout.cancel(t); });
};
*/
